import React, { useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-hot-toast';
import Spinner from './spinner/Spinner';
import { axiosInstancev2 } from '../utils/Axios/axiosInterceptorv2';

function ResendOnboardingEmail({ cohortId, toggleModal, cohortName }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    axiosInstancev2
      .post('/users/student/resend-onboarding', {
        cohort_id: cohortId,
      })
      .then(() => {
        toast.success('Resending onboarding emails! This might take a moment.');
        toggleModal();
      })
      .catch((error) => {
        toast.error(
          `Couldn't resend onboarding emails. ${
            error?.response?.data?.error || ''
          } Please try again`
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <form
      className="text-gray-700 space-y-4"
      onSubmit={(event) => handleSubmit(event)}
    >
      <p>
        Are you sure you want to resend onboarding emails to students in the{' '}
        <strong>{cohortName}</strong> cohort who have never logged in?
      </p>
      {isSubmitting ? (
        <div className="w-full flex align-middle justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className=" flex justify-between mt-8">
          <button
            className="border-[1px] border-claret-500 px-4 py-1 rounded-md text-claret-500 text-sm space-x-2 flex items-center"
            type="button"
            onClick={toggleModal}
          >
            <CancelIcon fontSize="inherit" />
            <p>Cancel</p>
          </button>
          <button
            className="bg-claret-500 px-4 py-1 rounded-md text-white text-sm space-x-2 flex items-center"
            type="submit"
          >
            <SendIcon fontSize="inherit" />
            <p>Resend Emails</p>
          </button>
        </div>
      )}
    </form>
  );
}

export default ResendOnboardingEmail;
